import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const DELETE_MASTER_REQUEST = "DELETE_MASTER_REQUEST";
export const DELETE_MASTER_SUCCESS = "DELETE_MASTER_SUCCESS";
export const DELETE_MASTER_FAIL = "DELETE_MASTER_FAIL";

export const delMaster = (email: IMaster["email"]) => (dispatch: any): any => {
  dispatch({ type: DELETE_MASTER_REQUEST });

  const token = getToken();

  return api
    .delMaster(token, email)
    .then((response: AxiosResponse) => {
      dispatch({ type: DELETE_MASTER_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: DELETE_MASTER_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
